import { useEffect } from 'react';

export const useRoutePreloader = () => {
  useEffect(() => {
    // Precargar rutas críticas después de un delay
    const preloadRoutes = () => {
      // Precargar destinos (más visitada)
      setTimeout(() => {
        import('../components/DestinosFiltrables');
      }, 1000);

      // Precargar cruceros
      setTimeout(() => {
        import('../pages/CrucerosPage');
      }, 2000);

      // Precargar asistencia
      setTimeout(() => {
        import('../pages/AsistenciaPage');
      }, 3000);

      // Precargar detalle destino
      setTimeout(() => {
        import('../components/DetalleDestino');
      }, 4000);
    };

    preloadRoutes();
  }, []);
};

// Hook para precargar en hover
export const useHoverPreload = () => {
  const preloadOnHover = (route) => {
    switch (route) {
      case '/destinos':
        import('../components/DestinosFiltrables');
        break;
      case '/cruceros':
        import('../pages/CrucerosPage');
        break;
      case '/asistencia':
        import('../pages/AsistenciaPage');
        break;
      default:
        break;
    }
  };

  return { preloadOnHover };
};
